// 根据部门名称返回对应的数据表单配置
// 统一管理所有部门的数据表单定义，避免重复代码
export const getDataForms = (deptName) => {
  // 规范化部门名称：去掉括号及其中内容，去掉首尾空格
  const normalizeName = (name) => {
    if (!name) return '';
    let n = name;
    // 中文括号
    n = n.replace(/（[^）]*）/g, '');
    // 英文括号
    n = n.replace(/\([^)]*\)/g, '');
    return n.trim();
  };

  const forms = {
    '科研处': [
      {
        key: 'research_funding',
        label: '到帐科研经费情况',
        fields: [
          { key: '年份', label: '年份', type: 'number', required: true },
          { key: '经费情况(万元)', label: '经费情况(万元)', type: 'number', required: true }
        ]
      },
      {
        key: 'research_teams',
        label: '省部级及以上科研团队',
        fields: [
          { key: '团队类别', label: '团队类别', type: 'select', required: true, options: [
            { value: '国家级', label: '国家级' },
            { value: '省部级', label: '省部级' }
          ]},
          { key: '团队名称', label: '团队名称', type: 'text', required: true },
          { key: '带头人姓名', label: '带头人姓名', type: 'text', required: true },
          { key: '资助时间', label: '资助时间', type: 'date', required: true },
          { key: '所属学科', label: '所属学科', type: 'text', required: true }
        ]
      },
      {
        key: 'research_awards',
        label: '近五年获得的代表性科研奖励',
        fields: [
          { key: '奖励类别', label: '奖励类别', type: 'select', required: true, options: [
            { value: '国家级奖励', label: '国家级奖励' },
            { value: '省部级奖励', label: '省部级奖励' },
            { value: '行业奖励', label: '行业奖励' }
          ]},
          { key: '获奖等级', label: '获奖等级', type: 'select', required: true, options: [
            { value: '一等奖', label: '一等奖' },
            { value: '二等奖', label: '二等奖' },
            { value: '三等奖', label: '三等奖' }
          ]},
          { key: '获奖项目名称', label: '获奖项目名称', type: 'text', required: true },
          { key: '获奖人', label: '获奖人', type: 'text', required: true },
          { key: '获奖年度', label: '获奖年度', type: 'number', required: true },
          { key: '主要支撑学科', label: '主要支撑学科', type: 'text', required: true }
        ]
      },
      {
        key: 'research_papers',
        label: '近五年发表的代表性学术论文、专著',
        fields: [
          { key: '名称', label: '名称', type: 'text', required: true },
          { key: '作者', label: '作者', type: 'text', required: true },
          { key: '时间', label: '时间', type: 'date', required: true },
          { key: '发表刊物/出版社', label: '发表刊物/出版社', type: 'text', required: true },
          { key: '备注(限100字)', label: '备注(限100字)', type: 'textarea', maxLength: 100 },
          { key: '主要支撑学科', label: '主要支撑学科', type: 'text', required: true }
        ]
      },
      {
        key: 'research_projects',
        label: '近五年承担的代表性科研项目',
        fields: [
          { key: '名称(下达编号)', label: '名称(下达编号)', type: 'text', required: true },
          { key: '来源', label: '来源', type: 'text', required: true },
          { key: '类别', label: '类别', type: 'select', required: true, options: [
            { value: '国家级项目', label: '国家级项目' },
            { value: '省部级项目', label: '省部级项目' },
            { value: '横向项目', label: '横向项目' },
            { value: '国际合作项目', label: '国际合作项目' },
            { value: '市科技项目', label: '市科技项目' }
          ]},
          { key: '起讫时间', label: '起讫时间', type: 'text', required: true },
          { key: '负责人', label: '负责人', type: 'text', required: true },
          { key: '本单位到帐经费(万元)', label: '本单位到帐经费(万元)', type: 'number', required: true }
        ]
      },
      {
        key: 'research_platforms',
        label: '代表性重点实验室、基地、中心等平台情况',
        fields: [
          { key: '类别', label: '类别', type: 'select', required: true, options: [
            { value: '国家实验室(基地)', label: '国家实验室(基地)' },
            { value: '全国重点实验室', label: '全国重点实验室' },
            { value: '国家新兴产业创新中心', label: '国家新兴产业创新中心' },
            { value: '国家制造业创新中心', label: '国家制造业创新中心' },
            { value: '国家技术创新中心', label: '国家技术创新中心' },
            { value: '国家临床医学研究中心', label: '国家临床医学研究中心' },
            { value: '国家产业技术工程化中心', label: '国家产业技术工程化中心' },
            { value: '国家大学科技园', label: '国家大学科技园' },
            { value: '"一带一路"联合实验室', label: '"一带一路"联合实验室' },
            { value: '国家重大科技基础设施', label: '国家重大科技基础设施' },
            { value: '国家科技资源共享服务平台', label: '国家科技资源共享服务平台' },
            { value: '国家野外科学观测研究站', label: '国家野外科学观测研究站' },
            { value: '国家医学中心', label: '国家医学中心' },
            { value: '国家高端智库', label: '国家高端智库' },
            { value: '国家级国际科技合作基地', label: '国家级国际科技合作基地' },
            { value: '国际联合研究中心', label: '国际联合研究中心' },
            { value: '教育部哲学社会科学实验室', label: '教育部哲学社会科学实验室' },
            { value: '教育部人文社科重点研究基地', label: '教育部人文社科重点研究基地' },
            { value: '中宣部区域国别中心', label: '中宣部区域国别中心' },
            { value: '教育部重点实验室', label: '教育部重点实验室' },
            { value: '教育部工程研究中心', label: '教育部工程研究中心' },
            { value: '教育部国际合作联合实验室', label: '教育部国际合作联合实验室' },
            { value: '浙江省实验室', label: '浙江省实验室' },
            { value: '全省重点实验室', label: '全省重点实验室' },
            { value: '浙江省工程研究中心', label: '浙江省工程研究中心' },
            { value: '浙江省大学科技园', label: '浙江省大学科技园' },
            { value: '高校技术转移转化中心省级试点', label: '高校技术转移转化中心省级试点' },
            { value: '浙江省协同创新中心', label: '浙江省协同创新中心' },
            { value: '浙江省文科实验室', label: '浙江省文科实验室' },
            { value: '浙江省学科交叉中心', label: '浙江省学科交叉中心' },
            { value: '浙江省高校新型智库', label: '浙江省高校新型智库' },
            { value: '浙江省哲学社会科学重点研究基地', label: '浙江省哲学社会科学重点研究基地' },
            { value: '浙江省新型智库', label: '浙江省新型智库' },
            { value: '浙江省哲学社会科学实验室', label: '浙江省哲学社会科学实验室' },
            { value: '外省重要科研平台', label: '外省重要科研平台' },
            { value: '其他省部级科研平台', label: '其他省部级科研平台' },
            { value: '浙江省软科学实验室', label: '浙江省软科学实验室' }
          ]},
          { key: '名称', label: '名称', type: 'text', required: true },
          { key: '批准部门', label: '批准部门', type: 'text', required: true },
          { key: '批准时间', label: '批准时间', type: 'date', required: true },
          { key: '主要支撑学科或专业', label: '主要支撑学科或专业', type: 'text', required: true }
        ]
      }
    ],
    '人事处': [
      {
        key: 'teacher_count',
        label: '基本条件数据',
        fields: [
          { key: '年份', label: '年份', type: 'number', required: true },
          { key: '专任教师总人数', label: '专任教师总人数', type: 'number', required: true },
          { key: '专任教师获博士学位人数', label: '专任教师获博士学位人数', type: 'number', required: true },
          { key: '专任教师获硕士学位人数', label: '专任教师获硕士学位人数', type: 'number', required: true },
          { key: '专任教师正高数量', label: '专任教师正高数量', type: 'number', required: true },
          { key: '专任教师副高数量', label: '专任教师副高数量', type: 'number', required: true },
          { key: '银龄教师总人数', label: '银龄教师总人数', type: 'number', required: true },
          { key: '银龄教师获博士学位人数', label: '银龄教师获博士学位人数', type: 'number', required: true },
          { key: '银龄教师获硕士学位人数', label: '银龄教师获硕士学位人数', type: 'number', required: true }
        ]
      }
    ],
    '教务处': [
      {
        key: 'teaching_teams',
        label: '省部级及以上教学团队',
        fields: [
          { key: '团队类别', label: '团队类别', type: 'select', required: true, options: [
            { value: '国家级', label: '国家级' },
            { value: '省部级', label: '省部级' }
          ]},
          { key: '团队名称', label: '团队名称', type: 'text', required: true },
          { key: '带头人姓名', label: '带头人姓名', type: 'text', required: true },
          { key: '资助时间', label: '资助时间', type: 'date', required: true },
          { key: '所属学科', label: '所属学科', type: 'text', required: true }
        ]
      },
      {
        key: 'teaching_awards',
        label: '近五年获得省部级及以上教学成果奖',
        fields: [
          { key: '奖励类别', label: '奖励类别', type: 'select', required: true, options: [
            { value: '国家级教学成果奖', label: '国家级教学成果奖' },
            { value: '省级教学成果奖', label: '省级教学成果奖' }
          ]},
          { key: '获奖等级', label: '获奖等级', type: 'select', required: true, options: [
            { value: '一等奖', label: '一等奖' },
            { value: '二等奖', label: '二等奖' },
            { value: '三等奖', label: '三等奖' }
          ]},
          { key: '获奖成果名称', label: '获奖成果名称', type: 'text', required: true },
          { key: '主要完成人(全部人员)', label: '主要完成人(全部人员)', type: 'text', required: true },
          { key: '获奖年度', label: '获奖年度', type: 'number', required: true },
          { key: '主要支撑学科或专业', label: '主要支撑学科或专业', type: 'text', required: true }
        ]
      },
      {
        key: 'teaching_platforms',
        label: '省部级及以上教学平台',
        fields: [
          { key: '类别', label: '类别', type: 'select', required: true, options: [
            { value: '国家级实验教学示范中心', label: '国家级实验教学示范中心' },
            { value: '国家级现代产业学院', label: '国家级现代产业学院' },
            { value: '国家级未来技术学院', label: '国家级未来技术学院' },
            { value: '国家级专业特色学院', label: '国家级专业特色学院' },
            { value: '国家教材建设重点研究基地', label: '国家教材建设重点研究基地' },
            { value: '国家产教融合平台', label: '国家产教融合平台' },
            { value: '教育部涉外法治人才协同培养创新基地', label: '教育部涉外法治人才协同培养创新基地' },
            { value: '浙江省重点建设实验教学示范中心', label: '浙江省重点建设实验教学示范中心' },
            { value: '浙江省重点支持现代产业学院', label: '浙江省重点支持现代产业学院' },
            { value: '浙江省大学生校外实践教育基地', label: '浙江省大学生校外实践教育基地' },
            { value: '浙江省研究生联合培养基地', label: '浙江省研究生联合培养基地' },
            { value: '浙江省教材建设研究基地', label: '浙江省教材建设研究基地' },
            { value: '浙江省产教融合基地', label: '浙江省产教融合基地' },
            { value: '浙江省科教融合学院', label: '浙江省科教融合学院' },
            { value: '外省重要教学平台', label: '外省重要教学平台' },
            { value: '浙江省基础学科拔尖学生培养基地', label: '浙江省基础学科拔尖学生培养基地' }
          ]},
          { key: '名称', label: '名称', type: 'text', required: true },
          { key: '批准部门', label: '批准部门', type: 'text', required: true },
          { key: '批准时间', label: '批准时间', type: 'date', required: true },
          { key: '主要支撑学科或专业', label: '主要支撑学科或专业', type: 'text', required: true }
        ]
      },
      {
        key: 'student_count',
        label: '全日制在校学生人数',
        fields: [
          { key: '年份', label: '年份', type: 'number', required: true },
          { key: '本科人数', label: '本科人数', type: 'number', required: true },
          { key: '专科人数', label: '专科人数', type: 'number', required: true },
          { key: '总人数', label: '总人数', type: 'number', computed: true, formula: (data) => (data['本科人数'] || data.undergraduate || 0) + (data['专科人数'] || data.college || 0) }
        ]
      }
    ],
    '国际事务处': [
      {
        key: 'international_exchange',
        label: '近五年国际交流情况',
        fields: [
          { key: '中外合作办学机构数', label: '中外合作办学机构数', type: 'number', required: true },
          { key: '中外合作办学项目数', label: '中外合作办学项目数', type: 'number', required: true },
          { key: '境外学生来华学习交流人数', label: '境外学生来华学习交流人数', type: 'number', required: true },
          { key: '赴境外交流访问学生人数', label: '赴境外交流访问学生人数', type: 'number', required: true }
        ]
      },
      {
        key: 'international_students',
        label: '全日制在校留学生人数',
        fields: [
          { key: '年份', label: '年份', type: 'number', required: true },
          { key: '学生人数', label: '学生人数', type: 'number', required: true },
          { key: '留学生人数', label: '留学生人数', type: 'number', required: true },
          { key: '总人数', label: '总人数', type: 'number', computed: true, formula: (data) => (data['学生人数'] || data.students || 0) + (data['留学生人数'] || data.international || 0) }
        ]
      }
    ],
    '研究生院(研究生工作部)': [
      {
        key: 'graduate_students',
        label: '全日制研究生在校学生人数',
        fields: [
          { key: '年份', label: '年份', type: 'number', required: true },
          { key: '硕士研究生', label: '硕士研究生', type: 'number', required: true },
          { key: '博士研究生', label: '博士研究生', type: 'number', required: true },
          { key: '留学生', label: '留学生', type: 'number', required: true },
          { key: '总人数', label: '总人数', type: 'number', computed: true, formula: (data) => (data['硕士研究生'] || data.master || 0) + (data['博士研究生'] || data.phd || 0) + (data['留学生'] || data.international || 0) }
        ]
      },
      {
        key: 'degree_application',
        label: '本单位申请新增学位授权情况',
        fields: [
          { key: '申请新增学位点名称', label: '申请新增学位点名称', type: 'text', required: true },
          { key: '申请授权级别类型', label: '申请授权级别类型', type: 'text', required: true }
        ]
      },
      {
        key: 'degree_points',
        label: '本单位现有学位点情况',
        fields: [
          { key: '学科/专业学位类别/专业名称', label: '学科/专业学位类别/专业名称', type: 'text', required: true },
          { key: '授权级别类型', label: '授权级别类型', type: 'text', required: true },
          { key: '授权批准时间', label: '授权批准时间', type: 'date', required: true },
          { key: '已毕业学生届数', label: '已毕业学生届数', type: 'number', required: true },
          { key: '近五年授予学位数', label: '近五年授予学位数', type: 'number', required: true }
        ]
      },
      {
        key: 'graduate_teaching_awards',
        label: '近五年获得省部级及以上教学成果奖',
        fields: [
          { key: '奖励类别', label: '奖励类别', type: 'select', required: true, options: [
            { value: '国家级教学成果奖', label: '国家级教学成果奖' },
            { value: '省级教学成果奖', label: '省级教学成果奖' }
          ]},
          { key: '获奖等级', label: '获奖等级', type: 'select', required: true, options: [
            { value: '一等奖', label: '一等奖' },
            { value: '二等奖', label: '二等奖' },
            { value: '三等奖', label: '三等奖' }
          ]},
          { key: '获奖成果名称', label: '获奖成果名称', type: 'text', required: true },
          { key: '主要完成人(全部人员)', label: '主要完成人(全部人员)', type: 'text', required: true },
          { key: '获奖年度', label: '获奖年度', type: 'number', required: true },
          { key: '主要支撑学科或专业', label: '主要支撑学科或专业', type: 'text', required: true }
        ]
      },
      {
        key: 'graduate_courses',
        label: '近五年代表性课程和专业',
        fields: [
          { key: '类别', label: '类别', type: 'text', required: true },
          { key: '名称', label: '名称', type: 'text', required: true },
          { key: '主讲教师/负责人', label: '主讲教师/负责人', type: 'text', required: true },
          { key: '批准年月', label: '批准年月', type: 'date', required: true },
          { key: '主要支撑学科或专业', label: '主要支撑学科或专业', type: 'text', required: true }
        ]
      },
      {
        key: 'graduate_student_achievements',
        label: '近五年在校生代表性成果',
        fields: [
          { key: '成果名称', label: '成果名称', type: 'text', required: true },
          { key: '成果详情', label: '成果详情', type: 'textarea', required: true },
          { key: '时间', label: '时间', type: 'date', required: true },
          { key: '学生姓名', label: '学生姓名', type: 'text', required: true },
          { key: '学位级别(学习方式/入学年月/学科专业)', label: '学位级别(学习方式/入学年月/学科专业)', type: 'text', required: true }
        ]
      },
      {
        key: 'graduate_platforms',
        label: '代表性重点实验室、基地、中心、重点学科、卓越计划等平台',
        fields: [
          { key: '类别', label: '类别', type: 'select', required: true, options: [
            { value: '教育部重点实验室', label: '教育部重点实验室' },
            { value: '教育部工程研究中心', label: '教育部工程研究中心' },
            { value: '教育部国际合作联合实验室', label: '教育部国际合作联合实验室' },
            { value: '浙江省实验室', label: '浙江省实验室' },
            { value: '全省重点实验室', label: '全省重点实验室' },
            { value: '浙江省工程研究中心', label: '浙江省工程研究中心' },
            { value: '浙江省大学科技园', label: '浙江省大学科技园' },
            { value: '高校技术转移转化中心省级试点', label: '高校技术转移转化中心省级试点' },
            { value: '浙江省协同创新中心', label: '浙江省协同创新中心' },
            { value: '浙江省文科实验室', label: '浙江省文科实验室' },
            { value: '浙江省学科交叉中心', label: '浙江省学科交叉中心' },
            { value: '浙江省高校新型智库', label: '浙江省高校新型智库' },
            { value: '浙江省哲学社会科学重点研究基地', label: '浙江省哲学社会科学重点研究基地' },
            { value: '浙江省新型智库', label: '浙江省新型智库' },
            { value: '浙江省哲学社会科学实验室', label: '浙江省哲学社会科学实验室' },
            { value: '外省重要科研平台', label: '外省重要科研平台' },
            { value: '其他省部级科研平台', label: '其他省部级科研平台' },
            { value: '浙江省软科学实验室', label: '浙江省软科学实验室' },
            { value: '国家实验室(基地)', label: '国家实验室(基地)' },
            { value: '全国重点实验室', label: '全国重点实验室' },
            { value: '国家新兴产业创新中心', label: '国家新兴产业创新中心' },
            { value: '国家制造业创新中心', label: '国家制造业创新中心' },
            { value: '国家技术创新中心', label: '国家技术创新中心' },
            { value: '国家临床医学研究中心', label: '国家临床医学研究中心' },
            { value: '国家产业技术工程化中心', label: '国家产业技术工程化中心' },
            { value: '国家大学科技园', label: '国家大学科技园' },
            { value: '"一带一路"联合实验室', label: '"一带一路"联合实验室' },
            { value: '国家重大科技基础设施', label: '国家重大科技基础设施' },
            { value: '国家科技资源共享服务平台', label: '国家科技资源共享服务平台' },
            { value: '国家野外科学观测研究站', label: '国家野外科学观测研究站' },
            { value: '国家医学中心', label: '国家医学中心' },
            { value: '国家高端智库', label: '国家高端智库' },
            { value: '国家级国际科技合作基地', label: '国家级国际科技合作基地' },
            { value: '国际联合研究中心', label: '国际联合研究中心' },
            { value: '教育部哲学社会科学实验室', label: '教育部哲学社会科学实验室' },
            { value: '教育部人文社科重点研究基地', label: '教育部人文社科重点研究基地' },
            { value: '中宣部区域国别中心', label: '中宣部区域国别中心' },
            { value: '国家级实验教学示范中心', label: '国家级实验教学示范中心' },
            { value: '国家级现代产业学院', label: '国家级现代产业学院' },
            { value: '国家级未来技术学院', label: '国家级未来技术学院' },
            { value: '国家级专业特色学院', label: '国家级专业特色学院' },
            { value: '国家教材建设重点研究基地', label: '国家教材建设重点研究基地' },
            { value: '国家产教融合平台', label: '国家产教融合平台' },
            { value: '浙江省重点建设实验教学示范中心', label: '浙江省重点建设实验教学示范中心' },
            { value: '浙江省重点支持现代产业学院', label: '浙江省重点支持现代产业学院' },
            { value: '浙江省大学生校外实践教育基地', label: '浙江省大学生校外实践教育基地' },
            { value: '浙江省研究生联合培养基地', label: '浙江省研究生联合培养基地' },
            { value: '浙江省教材建设研究基地', label: '浙江省教材建设研究基地' },
            { value: '浙江省产教融合基地', label: '浙江省产教融合基地' },
            { value: '浙江省科教融合学院', label: '浙江省科教融合学院' },
            { value: '外省重要教学平台', label: '外省重要教学平台' },
            { value: '教育部涉外法治人才协同培养创新基地', label: '教育部涉外法治人才协同培养创新基地' },
            { value: '浙江省基础学科拔尖学生培养基地', label: '浙江省基础学科拔尖学生培养基地' }
          ]},
          { key: '名称', label: '名称', type: 'text', required: true },
          { key: '批准时间', label: '批准时间', type: 'date', required: true },
          { key: '批准年月', label: '批准年月', type: 'date', required: true },
          { key: '主要支撑学科或专业', label: '主要支撑学科或专业', type: 'text', required: true }
        ]
      }
    ],
    // 博士授权点下的部门：审计
    // 审计相关三个方向公用同一套表单配置
    '审计': [
      {
        key: 'discipline_team',
        label: '学科队伍',
        fields: [
          { key: '年份', label: '年份', type: 'number', required: true },
          { key: '专任教师人数', label: '专任教师人数', type: 'number', required: true },
          { key: '其中:主持过或作为骨干成员参与过省部级及以上科研项目的比例', label: '其中:主持过或作为骨干成员参与过省部级及以上科研项目的比例', type: 'number', required: true },
          { key: '其中:具有审计及相关行业经历经验的比例', label: '其中:具有审计及相关行业经历经验的比例', type: 'number', required: true },
          { key: '高级职称比例', label: '高级职称比例', type: 'number', required: true },
          { key: '其中:正高级职称比例', label: '其中:正高级职称比例', type: 'number', required: true },
          { key: '博士学位比例', label: '博士学位比例', type: 'number', required: true },
          { key: '具有博士学位的青年教师(50岁以下)比例', label: '具有博士学位的青年教师(50岁以下)比例', type: 'number', required: true },
          { key: '行业教师人数', label: '行业教师人数', type: 'number', required: true },
          { key: '其中:具有审计专业技术资格或相关专业国家职业资格的比例', label: '其中:具有审计专业技术资格或相关专业国家职业资格的比例', type: 'number', required: true },
          { key: '骨干教师人数', label: '骨干教师人数', type: 'number', required: true },
          { key: '其中:博导人数', label: '其中:博导人数', type: 'number', required: true },
          { key: '其中:作为专业学术带头人', label: '其中:作为专业学术带头人', type: 'number', required: true },
          { key: '其中:师均主持省部级及以上科研项目或主持审计实务类课题数', label: '其中:师均主持省部级及以上科研项目或主持审计实务类课题数', type: 'number', required: true },
          { key: '国家级人才', label: '国家级人才', type: 'number', required: true },
          { key: '审计相关省级人才', label: '审计相关省级人才', type: 'number', required: true }
        ]
      },
      {
        key: 'talent_training',
        label: '人才培养',
        fields: [
          { key: '年份', label: '年份', type: 'number', required: true },
          { key: '省级及以上审计相关专业优秀硕士学位论文数', label: '省级及以上审计相关专业优秀硕士学位论文数', type: 'number', required: true },
          { key: '建立审计相关专业教学案例库数', label: '建立审计相关专业教学案例库数', type: 'number', required: true },
          { key: '新增省部级及以上教学案例(篇)', label: '新增省部级及以上教学案例(篇)', type: 'number', required: true },
          { key: '师均开发教学案例(篇)', label: '师均开发教学案例(篇)', type: 'number', required: true },
          { key: '省级规划教材或优秀教材数', label: '省级规划教材或优秀教材数', type: 'number', required: true },
          { key: '校级及以上教学名师', label: '校级及以上教学名师', type: 'number', required: true }
        ]
      },
      {
        key: 'scientific_research',
        label: '科学研究',
        fields: [
          { key: '年份', label: '年份', type: 'number', required: true },
          { key: '新增主持国家级重大、重点项目数', label: '新增主持国家级重大、重点项目数', type: 'number', required: true },
          { key: '新增省部级科研成果奖', label: '新增省部级科研成果奖', type: 'number', required: true },
          { key: '新增主持审计相关省部级项目数', label: '新增主持审计相关省部级项目数', type: 'number', required: true },
          { key: '师均审计相关科研成果数(含发表学术论文、决策咨询报告、案例分析报告等)', label: '师均审计相关科研成果数(含发表学术论文、决策咨询报告、案例分析报告等)', type: 'number', required: true },
          { key: '年师均科研到账经费(万元)', label: '年师均科研到账经费(万元)', type: 'number', required: true },
          { key: '在CSSCI或SSCI上新增发表审计相关高水平学术论文(篇)', label: '在CSSCI或SSCI上新增发表审计相关高水平学术论文(篇)', type: 'number', required: true }
        ]
      },
      {
        key: 'academic_exchange',
        label: '学术交流',
        fields: [
          { key: '年份', label: '年份', type: 'number', required: true },
          { key: '师均参加校外组织的审计相关活动次数', label: '师均参加校外组织的审计相关活动次数', type: 'number', required: true }
        ]
      }
    ],
    // 博士授权点下的部门：智能科学与技术
    '智能科学与技术': [
      {
        key: 'discipline_team',
        label: '学科队伍',
        fields: [
          { key: '年份', label: '年份', type: 'number', required: true },
          { key: '专任教师人数', label: '专任教师人数', type: 'number', required: true },
          { key: '45周岁以下教师占比', label: '45周岁以下教师占比', type: 'number', required: true },
          { key: '高级职称教师占比', label: '高级职称教师占比', type: 'number', required: true },
          { key: '博士学位教师占比', label: '博士学位教师占比', type: 'number', required: true },
          { key: '其中:具有本学科相关的博士学位教师占比', label: '其中:具有本学科相关的博士学位教师占比', type: 'number', required: true },
          { key: '学科带头人数量', label: '学科带头人数量', type: 'number', required: true },
          { key: '学术骨干数量', label: '学术骨干数量', type: 'number', required: true },
          { key: '国家级人才数量', label: '国家级人才数量', type: 'number', required: true },
          { key: '省级人才数量', label: '省级人才数量', type: 'number', required: true },
          { key: '博士生导师数量', label: '博士生导师数量', type: 'number', required: true }
        ]
      },
      {
        key: 'talent_training',
        label: '人才培养',
        fields: [
          { key: '年份', label: '年份', type: 'number', required: true },
          { key: '年均硕士生发表高水平学术论文、申请发明专利款', label: '年均硕士生发表高水平学术论文、申请发明专利款', type: 'number', required: true },
          { key: '年均硕士生参加省级及以上科研项目数', label: '年均硕士生参加省级及以上科研项目数', type: 'number', required: true },
          { key: '升博率', label: '升博率', type: 'number', required: true },
          { key: '新增省级以上教学平台、实践基地和实验室数', label: '新增省级以上教学平台、实践基地和实验室数', type: 'number', required: true },
          { key: '新增省级教学、科研团队数', label: '新增省级教学、科研团队数', type: 'number', required: true },
          { key: '新增省级及以上教学成果奖', label: '新增省级及以上教学成果奖', type: 'number', required: true }
        ]
      },
      {
        key: 'scientific_research',
        label: '科学研究',
        fields: [
          { key: '年份', label: '年份', type: 'number', required: true },
          { key: '新增国家级项目数', label: '新增国家级项目数', type: 'number', required: true },
          { key: '其中:新增国家级重大、重点项目数', label: '其中:新增国家级重大、重点项目数', type: 'number', required: true },
          { key: '新增主持省部级项目数', label: '新增主持省部级项目数', type: 'number', required: true },
          { key: '其中:新增省部级重大、重点项目数', label: '其中:新增省部级重大、重点项目数', type: 'number', required: true },
          { key: '省部级及以上科研项目累计到账经费(万元)', label: '省部级及以上科研项目累计到账经费(万元)', type: 'number', required: true },
          { key: '师均主持省部级及以上项目数', label: '师均主持省部级及以上项目数', type: 'number', required: true },
          { key: '师均主持省部级及以上科研到账经费(万元)', label: '师均主持省部级及以上科研到账经费(万元)', type: 'number', required: true },
          { key: '在SCI、SSCI、CSSCI收录期刊和一级期刊(浙大标准)及以上期刊发表新增本学科论文数(篇)', label: '在SCI、SSCI、CSSCI收录期刊和一级期刊(浙大标准)及以上期刊发表新增本学科论文数(篇)', type: 'number', required: true },
          { key: '其中:TOP期刊、权威期刊新增发表数', label: '其中:TOP期刊、权威期刊新增发表数', type: 'number', required: true },
          { key: '新增转化或应用的授权发明专利数', label: '新增转化或应用的授权发明专利数', type: 'number', required: true },
          { key: '新增省部级科技奖二等奖及以上数', label: '新增省部级科技奖二等奖及以上数', type: 'number', required: true },
          { key: '新增省部级科研平台', label: '新增省部级科研平台', type: 'number', required: true }
        ]
      },
      {
        key: 'academic_exchange',
        label: '学术交流',
        fields: [
          { key: '年份', label: '年份', type: 'number', required: true },
          { key: '新增主办、承办国际学术会议或全国学术会议(次)', label: '新增主办、承办国际学术会议或全国学术会议(次)', type: 'number', required: true },
          { key: '师均参加国内外学术会议次数', label: '师均参加国内外学术会议次数', type: 'number', required: true },
          { key: '其中:参加国际学术会议人次', label: '其中:参加国际学术会议人次', type: 'number', required: true },
          { key: '年均邀请境内外专家报告次数', label: '年均邀请境内外专家报告次数', type: 'number', required: true },
          { key: '与境外高水平机构开展合作项目数', label: '与境外高水平机构开展合作项目数', type: 'number', required: true },
          { key: '研究生新增获全额资助参加境内外学术交流人数', label: '研究生新增获全额资助参加境内外学术交流人数', type: 'number', required: true }
        ]
      }
    ],
    // 博士授权点下的部门：生物与医药
    '生物与医药': [
      {
        key: 'discipline_team',
        label: '学科队伍',
        fields: [
          { key: '年份', label: '年份', type: 'number', required: true },
          { key: '专任教师人数', label: '专任教师人数', type: 'number', required: true },
          { key: '其中:主持过或作为骨干参加过国家级或省部级重大、重点工程类科研项目比例', label: '其中:主持过或作为骨干参加过国家级或省部级重大、重点工程类科研项目比例', type: 'number', required: true },
          { key: '其中:拥有主持行业产业课题研究、项目研发经历的比例', label: '其中:拥有主持行业产业课题研究、项目研发经历的比例', type: 'number', required: true },
          { key: '行业教师人数', label: '行业教师人数', type: 'number', required: true },
          { key: '骨干教师', label: '骨干教师', type: 'number', required: true },
          { key: '其中:培养过生物与医药类博士比例(人数)', label: '其中:培养过生物与医药类博士比例(人数)', type: 'number', required: true },
          { key: '新增国家级人才(定义见说明第五条)', label: '新增国家级人才(定义见说明第五条)', type: 'number', required: true },
          { key: '新增省级人才(定义见说明第五条)', label: '新增省级人才(定义见说明第五条)', type: 'number', required: true }
        ]
      },
      {
        key: 'talent_training',
        label: '人才培养',
        fields: [
          { key: '年份', label: '年份', type: 'number', required: true },
          { key: '新增省级以上教学平台、实践基地和实验室数', label: '新增省级以上教学平台、实践基地和实验室数', type: 'number', required: true },
          { key: '新增省级教学、科研团队', label: '新增省级教学、科研团队', type: 'number', required: true },
          { key: '新增省级及以上教学成果奖(定义见说明第五条, 含参与)', label: '新增省级及以上教学成果奖(定义见说明第五条, 含参与)', type: 'number', required: true }
        ]
      },
      {
        key: 'scientific_research',
        label: '科学研究',
        fields: [
          { key: '年份', label: '年份', type: 'number', required: true },
          { key: '新增省部级及以上科研一等奖及以上奖项数', label: '新增省部级及以上科研一等奖及以上奖项数', type: 'number', required: true },
          { key: '其中:新增国家级科研二等奖及以上奖项数(含参与)', label: '其中:新增国家级科研二等奖及以上奖项数(含参与)', type: 'number', required: true },
          { key: '新增国家或省部级科研平台', label: '新增国家或省部级科研平台', type: 'number', required: true },
          { key: '新增国家级项目数', label: '新增国家级项目数', type: 'number', required: true },
          { key: '其中:新增国家级重大、重点项目数', label: '其中:新增国家级重大、重点项目数', type: 'number', required: true },
          { key: '新增省部级项目数', label: '新增省部级项目数', type: 'number', required: true },
          { key: '其中:新增省部级重大、重点项目数', label: '其中:新增省部级重大、重点项目数', type: 'number', required: true },
          { key: '新增500万以上重大横向项目数', label: '新增500万以上重大横向项目数', type: 'number', required: true },
          { key: '年师均科研到账经费(万元)', label: '年师均科研到账经费(万元)', type: 'number', required: true },
          { key: '年均科研到账总经费(万元)', label: '年均科研到账总经费(万元)', type: 'number', required: true },
          { key: '在CNS上新增发表论文(含子刊)', label: '在CNS上新增发表论文(含子刊)', type: 'number', required: true }
        ]
      }
    ],
  };
  
  const normalized = normalizeName(deptName);
  /** 博士授权点：部门名 → 表单配置键（须与 phd_matrix_export.PHD_FORM_FIELDS 登记一致） */
  const PHD_DEPT_FORM_KEY = {
    生物与制药: '生物与医药',
    人工智能: '智能科学与技术',
    人工智能应用: '智能科学与技术',
    智能系统与工程: '智能科学与技术',
    海洋经济与国家审计: '审计',
    民营经济与内部审计: '审计',
    数字经济系统治理与审计: '审计',
    生物与环境学院: '生物与医药',
    现代农学院: '生物与医药'
  };
  const key = PHD_DEPT_FORM_KEY[normalized] || normalized;
  const out = forms[key] ?? forms[deptName];
  if (out === undefined) {
    console.error(
      `[getDataForms] 未配置部门表单，返回空列表（须在 dataForms 中登记）: deptName=${JSON.stringify(deptName)} key=${JSON.stringify(key)}`
    );
    return [];
  }
  return out;
};

// 获取简化的表单配置（只包含key和label，用于显示）
export const getDataFormsSimple = (deptName) => {
  const forms = getDataForms(deptName);
  return forms.map(form => ({
    key: form.key,
    label: form.label
  }));
};

// ─── 博士授权点共享常量 ────────────────────────────────────────────

/** 博士授权点四种指标类型 */
export const PHD_TYPES = [
  'discipline_team',
  'talent_training',
  'scientific_research',
  'academic_exchange',
];

/** 判断是否为博士授权点部门类型 */
export const isPhdDeptType = (type) => type === '博士授权点';

/** 校验年份是否合法（1900-2100） */
export const isValidYear = (y) => {
  if (y == null || y === '' || isNaN(Number(y))) return false;
  const n = Number(y);
  return n >= 1900 && n <= 2100;
};

/** 从 submission 对象中提取年份（兼容新旧格式） */
export function getSubYear(sub) {
  if (!sub) return null;
  if (isValidYear(sub.year)) return Number(sub.year);
  const c = sub.data_content || {};
  const y = c.年份 ?? c.year;
  if (isValidYear(y)) return Number(y);
  return null;
}

/**
 * 从 dataForms 数组中获取指定数据类型的字段定义
 * @param {Array} dataForms - getDataForms 返回的表单配置数组
 * @param {string} dataType - 数据类型 key
 * @returns {Array} 字段定义数组
 */
export function getFieldsForDataType(dataForms, dataType) {
  if (!dataForms || !dataType) return [];
  const formConfig = dataForms.find(f => f.key === dataType);
  return formConfig ? formConfig.fields : [];
}

/**
 * 从 dataForms 数组中获取指定数据类型的显示标签
 * @param {Array} dataForms - getDataForms 返回的表单配置数组
 * @param {string} dataType - 数据类型 key
 * @returns {string} 标签文本
 */
export function getDataTypeLabel(dataForms, dataType) {
  if (!dataForms || !dataType) return dataType;
  const formConfig = dataForms.find(f => f.key === dataType);
  return formConfig ? formConfig.label : dataType;
}

/**
 * 格式化字段值用于表格显示
 * @param {Object} field - 字段定义（含 type, options）
 * @param {*} value - 原始值
 * @returns {string} 格式化后的显示值
 */
export function formatFieldValue(field, value) {
  if (value === undefined || value === null || value === '') return '-';

  if (field.type === 'date' && value) {
    try {
      const d = new Date(value);
      if (!isNaN(d.getTime())) {
        const y = d.getFullYear();
        const m = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${y}-${m}-${day}`;
      }
    } catch (e) { /* ignore */ }
    return value;
  }

  if (field.type === 'daterange' && Array.isArray(value)) {
    return `${value[0] || ''} ~ ${value[1] || ''}`;
  }

  if (field.type === 'select' && field.options) {
    const option = field.options.find(opt => opt.value === value);
    return option ? option.label : value;
  }

  return String(value);
}

/** 判断字段标签是否为子字段（以"其中:"开头） */
export const isSubField = (label) => label.startsWith('其中:');

/**
 * 从 data_content 对象中安全提取字段值
 * 返回 undefined 表示无值（区别于 null/0 等有效值）
 */
export function getFieldValue(dc, fieldKey) {
  if (!dc || typeof dc !== 'object') return undefined;
  const v = dc[fieldKey];
  return (v !== undefined && v !== null && v !== '') ? v : undefined;
}

